import React from 'react'

const PhotoGallery_1 = () => {
    return (
        <>

            <section>
                <div className="inn-ban">
                    <div className="container">
                        <div className="row">
                            <h1>Photo gallery</h1>
                            <p>
                                lacinia viverra lectus. Fusce imperdiet ullamcorper metus eu
                                fringilla
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            {/* END */}
            {/* START */}
            <section>
                <div className="wedd-gall-pg-v1">
                    <div className="container">
                        <div className="row">
                            <div className="pr-bio-c pr-bio-gal" id="gallery">
                                <div id="image-gallery">
                                    <div className="pro-gal-imag">
                                        <div className="img-wrapper">
                                            <a href="#!">
                                                <img
                                                    src="https://images.unsplash.com/photo-1508921912186-1d1a45ebb3c1?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8cGhvdG98ZW58MHx8MHx8fDA%3D"
                                                    className="img-responsive"
                                                    alt=""
                                                />
                                            </a>
                                            <div className="img-overlay">
                                                <i className="fa fa-arrows-alt" aria-hidden="true" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pro-gal-imag">
                                        <div className="img-wrapper">
                                            <a href="#!">
                                                <img
                                                    src="images/gallery/2.jpg"
                                                    className="img-responsive"
                                                    alt=""
                                                />
                                            </a>
                                            <div className="img-overlay">
                                                <i className="fa fa-arrows-alt" aria-hidden="true" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pro-gal-imag">
                                        <div className="img-wrapper">
                                            <a href="#!">
                                                <img
                                                    src="images/gallery/3.jpg"
                                                    className="img-responsive"
                                                    alt=""
                                                />
                                            </a>
                                            <div className="img-overlay">
                                                <i className="fa fa-arrows-alt" aria-hidden="true" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pro-gal-imag">
                                        <div className="img-wrapper">
                                            <a href="#!">
                                                <img
                                                    src="images/gallery/4.jpg"
                                                    className="img-responsive"
                                                    alt=""
                                                />
                                            </a>
                                            <div className="img-overlay">
                                                <i className="fa fa-arrows-alt" aria-hidden="true" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pro-gal-imag">
                                        <div className="img-wrapper">
                                            <a href="#!">
                                                <img
                                                    src="images/gallery/5.jpg"
                                                    className="img-responsive"
                                                    alt=""
                                                />
                                            </a>
                                            <div className="img-overlay">
                                                <i className="fa fa-arrows-alt" aria-hidden="true" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pro-gal-imag">
                                        <div className="img-wrapper">
                                            <a href="#!">
                                                <img
                                                    src="images/gallery/6.jpg"
                                                    className="img-responsive"
                                                    alt=""
                                                />
                                            </a>
                                            <div className="img-overlay">
                                                <i className="fa fa-arrows-alt" aria-hidden="true" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pro-gal-imag">
                                        <div className="img-wrapper">
                                            <a href="#!">
                                                <img
                                                    src="images/gallery/7.jpg"
                                                    className="img-responsive"
                                                    alt=""
                                                />
                                            </a>
                                            <div className="img-overlay">
                                                <i className="fa fa-arrows-alt" aria-hidden="true" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pro-gal-imag">
                                        <div className="img-wrapper">
                                            <a href="#!">
                                                <img
                                                    src="images/gallery/8.jpg"
                                                    className="img-responsive"
                                                    alt=""
                                                />
                                            </a>
                                            <div className="img-overlay">
                                                <i className="fa fa-arrows-alt" aria-hidden="true" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pro-gal-imag">
                                        <div className="img-wrapper">
                                            <a href="#!">
                                                <img
                                                    src="images/gallery/9.jpg"
                                                    className="img-responsive"
                                                    alt=""
                                                />
                                            </a>
                                            <div className="img-overlay">
                                                <i className="fa fa-arrows-alt" aria-hidden="true" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pro-gal-imag">
                                        <div className="img-wrapper">
                                            <a href="#!">
                                                <img
                                                    src="images/couples/7.jpg"
                                                    className="img-responsive"
                                                    alt=""
                                                />
                                            </a>
                                            <div className="img-overlay">
                                                <i className="fa fa-arrows-alt" aria-hidden="true" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pro-gal-imag">
                                        <div className="img-wrapper">
                                            <a href="#!">
                                                <img
                                                    src="images/couples/8.jpg"
                                                    className="img-responsive"
                                                    alt=""
                                                />
                                            </a>
                                            <div className="img-overlay">
                                                <i className="fa fa-arrows-alt" aria-hidden="true" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pro-gal-imag">
                                        <div className="img-wrapper">
                                            <a href="#!">
                                                <img
                                                    src="images/couples/9.jpg"
                                                    className="img-responsive"
                                                    alt=""
                                                />
                                            </a>
                                            <div className="img-overlay">
                                                <i className="fa fa-arrows-alt" aria-hidden="true" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END */}

        </>

    )
}

export default PhotoGallery_1